/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'

import {
  faGitAlt,
  faHtml5,
  faJsSquare,
  faNodeJs,
  faPython,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const About = () => {
  const aboutArray = 'About Me'.split('')

  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={aboutArray}
              idx={15}
            />
          </h1>
          <p>I'm Omar Abdelrazek, a Computer Science and Information Security student at John Jay College in New York. I build secure agent execution tools, backend services, and responsive web applications.</p>
          <p>I'm the founder and developer of Kestrel, a private security startup in development focused on keeping autonomous AI agents within authorized assignments. I also build websites for local businesses and support product research and development workflows at Ape AI.</p>
          <p><strong>John Jay College · CUNY</strong><br />B.S. Computer Science and Information Security<br />Expected May 2028</p>
          <p>Relevant study: C++ Programming, Calculus I–III, Linear Algebra, and Calculus Based Physics. Harvard CS50 Introduction to Computer Science, completed.</p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faPython} color="#c82f22" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faReact} color="#c82f22" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faNodeJs} color="#c82f22" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faHtml5} color="#c82f22" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#c82f22" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#c82f22" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default About
